import { defineStore } from 'pinia'
import type { AssessmentTab, JourneyStage } from '../types/overall-assessment.types'

const initialJourney = () => ({
  stage: 'assessment' as JourneyStage,
  hasVisitedCarePlan: false,
  activeTab: 'Risk Assessment' as AssessmentTab,
  riskAssessmentSelection: [] as string[],
})

export type OverallAssessmentJourney = ReturnType<typeof initialJourney>

export const useOverallAssessmentStore = defineStore('overallAssessment', {
  state: (): OverallAssessmentJourney => initialJourney(),

  actions: {
    resume(payload: OverallAssessmentJourney): void {
      Object.assign(this, payload)
    },

    reset(): void {
      Object.assign(this, initialJourney())
    },
  },
})
